import {
  Box,
  Typography,
  Grid,
  Chip,
  IconButton,
  Button,
  Divider,
  Toolbar,
  Snackbar,
  Alert,
  CssBaseline,
  Container,
} from "@mui/material";
import { useState, useEffect, useContext } from "react";
import RequestCode from "../Components/RequestCode";
import ResponseCode from "../Components/ResponseCode";
import Parameters from "../Components/Parameters";
import FooterNavigation from "../Components/FooterNavigation";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import addSpaces from "../helpers/addSpaces";
import { RegionContext } from "../RegionContext";
import { Helmet } from "react-helmet";

export default function ApiDetailPage(props) {
  const { api } = useParams();
  const [apiData, setApiData] = useState({});
  const { data } = useContext(RegionContext);

  useEffect(() => {
    let formattedText = addSpaces(api);
    setApiData(data.api_collection[formattedText]);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [api, data.api_collection]);

  return (
    <>
      <Helmet>
        <title>{apiData?.endpoint_name}</title>
      </Helmet>
      <Box className="api-details-page">
        <Grid container spacing={0} zeroMinWidth>
          <Grid item xs={12} md={7} sm={12} xl={7} zeroMinWidth>
            <Box className="api-details-page-left">
              <Typography id="api-title">{apiData?.endpoint_name}</Typography>

              <Box id="api-url-box">
                <Chip
                  className="chips"
                  sx={{
                    mr: 1.5,
                    background:
                      apiData?.endpoint_method?.toLowerCase() === "get"
                        ? "#0e9b71"
                        : apiData?.endpoint_method?.toLowerCase() === "delete"
                        ? "#ec6b6b"
                        : "#00bcd4",
                  }}
                  label={
                    apiData?.endpoint_method?.toLowerCase() === "delete"
                      ? "del"
                      : apiData?.endpoint_method
                  }
                  size="small"
                />
                <Typography id="api-link" sx={{ flex: 1 }}>
                  {apiData?.endpoint}
                </Typography>

                <IconButton
                  onClick={() => props.copyClipBoard(apiData?.endpoint)}
                  aria-label="delete"
                  size="small"
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Box>

              <Typography id="api-description">
                {apiData?.endpoint_description}
              </Typography>

              <Divider className="divider" />

              {apiData?.request_parameters && (
                <Box>
                  <Typography className="label-caps">
                    Request Parameters
                  </Typography>
                  <Parameters data={apiData?.request_parameters} />
                </Box>
              )}

              {apiData?.request_parameters_object ? (
                Object.keys(apiData?.request_parameters_object).map(
                  (item, index) => {
                    return (
                      <>
                        <Box sx={{ mt: "25px" }}>
                          <Typography className="label-normal">
                            {item}
                          </Typography>
                          <Parameters
                            data={apiData?.request_parameters_object[item]}
                          />
                        </Box>

                        <Divider className="divider" />
                      </>
                    );
                  }
                )
              ) : (
                <Divider className="divider" />
              )}

              <Box>
                <Typography className="label-caps">
                  Response Parameters
                </Typography>
                <Parameters data={apiData?.response_parameters} />
              </Box>

              {apiData?.response_parameters_object &&
                Object.keys(apiData?.response_parameters_object).map(
                  (item, index) => {
                    return (
                      <Box sx={{ mt: "25px" }}>
                        <Typography className="label-normal">{item}</Typography>
                        <Parameters
                          data={apiData?.response_parameters_object[item]}
                        />
                      </Box>
                    );
                  }
                )}

              <Divider className="divider" />

              <Box sx={{ display: { xs: "none", md: "initial" } }}>
                <FooterNavigation
                  api={api}
                  data={Object.keys(data.api_collection)}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sm={12} xl={5} zeroMinWidth>
            <Box className="request-box api-details-page-right">
              {apiData?.request_code && (
                <RequestCode
                  copyFn={props.copyClipBoard}
                  type="Request"
                  code={apiData.request_code}
                />
              )}
              <br />
              {apiData?.response_code && (
                <ResponseCode
                  copyFn={props.copyClipBoard}
                  type="Response"
                  code={apiData?.response_code}
                />
              )}

              <Divider
                sx={{ display: { xs: "block", md: "none" } }}
                className="divider"
              />

              <Box
                id="footer-responsive-box"
                sx={{ display: { xs: "initial", md: "none" } }}
              >
                <FooterNavigation
                  api={api}
                  data={Object.keys(data.api_collection)}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
